import { DEFAULT_PAGINATE_OPTIONS_LIST } from './../utils/paginate.utils';
import { MateriaInterface } from '../models/materia.model';
import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { shareReplay } from 'rxjs';
import { PaginateOptions } from '../utils/paginate.utils';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class MateriasPlanService extends ApiService<MateriaInterface> {
  url = "materiaPlan";
  urlPlan =  environment.backendUrl + "planes";

  override getData = (paginateOptions: PaginateOptions = { ...DEFAULT_PAGINATE_OPTIONS_LIST }, ignoreCache: boolean = false): any => {
    // Espera que el filtro principal sea el id del plan
    const planId = paginateOptions.mainValueToFilter;
    const cacheKey = `${JSON.stringify(paginateOptions)}-plan-${planId}`;
    let apiUrl = this.getApiUrl();
    if (planId) {
      apiUrl = `${this.urlPlan}/${planId}/materias`;
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: {
            ...paginateOptions
          }
        }).pipe(shareReplay())
      );
    } else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: {
            ...paginateOptions
          }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  override delete = (id: number, motivo?: string, comment?: string) => {
    return this.http.request('DELETE', `${this.getApiUrl()}/delete/${id}`, {
      body: { motivo, comment }
    });
  }
  override restore = (id: number, motivo?: string, comment?: string) => {
    return this.http.request('PATCH', `${this.getApiUrl()}/restore/${id}`, {
      body: { motivo, comment }
    });
  }
  getMateriasByNivelModalidad = (paginateOptions : PaginateOptions , idnivel: number, idmodalidad: number, ignoreCache: boolean = false) => {
    const cacheKey = `materias-nivel-${idnivel}-modalidad-${idmodalidad}-${JSON.stringify(paginateOptions)}`;
    const apiUrl = `${this.getApiUrl()}/materias/${idnivel}/${idmodalidad}`;
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: paginateOptions}).pipe(shareReplay())
      );
    } else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: {
            ...paginateOptions
          }}).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  getMateriasByPlan = (planId: number, paginateOptions : PaginateOptions , ignoreCache: boolean = false) => {
    const cacheKey = `materias-plan-${planId}-${JSON.stringify(paginateOptions)}`;
    const apiUrl = `${this.urlPlan}/${planId}/materias`;
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: paginateOptions}).pipe(shareReplay())
      );
    } else if (ignoreCache) {
      this._getContent.delete(cacheKey);
      this._getContent.set(cacheKey,
        this.http.get(apiUrl, {
          params: {
            ...paginateOptions
          }}).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
}
